import type { ParseItemError } from "./ParseItemError";

export enum ParseItemsFromExcelResultParsingResult {
    "ITEMS_FILE_ERROR" = "ITEMS_FILE_ERROR",
    "ITEMS_FILE_SUCCESS" = "ITEMS_FILE_SUCCESS",
    "ITEMS_FILE_IN_PROGRESS" = "ITEMS_FILE_IN_PROGRESS"
}
export type ParseItemsFromExcelResult = {
    /**
     * @type string
    */
    parsingResult: ParseItemsFromExcelResultParsingResult;
    /**
     * @type string | undefined
    */
    errorTitle?: string;
    /**
     * @type string | undefined
    */
    error?: string;
    /**
     * @type array | undefined
    */
    errorList?: ParseItemError[];
};
